export * from './version';
export * from './config';
export * from './git-info';

// Fallback for environments that haven't added ENABLED_LANGUAGES to their config yet.
// Named imports (import { X }) fail at compile time if X doesn't exist in the module,
// so we spread the namespace into a plain object to bypass webpack's static resolution.
import * as _config from './config';
const _cfg = { ..._config } as Record<string, unknown>;
export const ENABLED_LANGUAGES: string[] = Array.isArray(_cfg['ENABLED_LANGUAGES'])
  ? (_cfg['ENABLED_LANGUAGES'] as string[])
  : ['en-US'];

// Frontend telemetry receiver (Grafana Faro / PCG) (FWX-5881). Deployed
// config.*.ts files are generated per-region and may omit these keys, so we
// read them defensively via the same namespace spread. Both URL and key must
// be set for FsTelemetryService to emit; either absent/empty keeps telemetry
// in no-op mode (init() short-circuits without loading the Faro SDK). Per-env
// endpoint + key come from FWX-5657.
export const IS_FARO_ENABLED: boolean = _cfg['IS_FARO_ENABLED'] !== false;
export const FARO_RECEIVER_URL: string =
  typeof _cfg['FARO_RECEIVER_URL'] === 'string' ? (_cfg['FARO_RECEIVER_URL'] as string) : '';
export const FARO_API_KEY: string =
  typeof _cfg['FARO_API_KEY'] === 'string' ? (_cfg['FARO_API_KEY'] as string) : '';
